import React, { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import { API_URL, IMAGE_URL } from "../../utils/constant";
import {
    getLogedInUser
} from "../../actions/users";
import { useSelector, useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import img2 from "../../assets/images/dummyImage.png";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import Pagination from "../Pagination/Pagination";
import { uploadCertificate, getCertificate, requestPrivatePolicy, uploadCertificateupdate, getCertificateSubOrg, deleteDocument, bulkDeleteDocuments } from "../../actions/riskManagement";
import axios from "axios";
import DatePicker from "react-datepicker";

const TrustPanel = () => {
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            .document-type-selector {
                display: flex;
                gap: 10px;
            }
            .document-type-item {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 10px 15px;
                border-radius: 4px;
                cursor: pointer;
                transition: all 0.3s ease;
                width: 100%;
            }
            .document-type-item i {
                font-size: 16px;
            }
            .document-type-item:hover {
                opacity: 0.9;
            }
            .document-type-item span {
                font-size: 14px;
            }
            .document-type-cell {
                padding: 8px !important;
            }
            .document-type-badge {
                display: inline-flex;
                align-items: center;
                gap: 6px;
                padding: 4px 8px;
                border-radius: 4px;
                font-size: 13px;
            }
            .document-type-badge.private {
                background-color: #e3f2fd;
                border: 1px solid #2196f3;
                color: #2196f3;
            }
            .document-type-badge.public {
                background-color: #e8f5e9;
                border: 1px solid #4caf50;
                color: #4caf50;
            }
            .document-type-badge i {
                font-size: 14px;
            }
            .document-type-badge.na {
                background-color: #f8f9fa;
                border: 1px solid #ced4da;
                color: #6c757d;
            }
            .document-type-badge.na .na-text {
                font-size: 13px;
                font-style: italic;
            }
            .upload-doc-button {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 8px 16px !important;
                font-size: 14px;
            }
            .upload-doc-button i {
                font-size: 16px;
            }
        `;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);
    const { orgId, subOrgId } = useParams();
    const id = useSelector(state => {
        if (orgId) {
            return orgId;
        } else {
            return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
        }
    });
    let profilePic = img2;
    if (
        JSON.parse(localStorage.getItem("user")).logo &&
        JSON.parse(localStorage.getItem("user")).logo != ""
    )
        profilePic = `${IMAGE_URL}${JSON.parse(localStorage.getItem("user")).logo}`;
    const data = useSelector((state) => state?.users?.logedInUser?.data);
    const certificate = useSelector((state) => state?.riskManagement?.certificate);
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [primaryContactName, setPrimaryContactName] = useState("");
    const [phone, setPhone] = useState("");
    const [isModal, setModal] = useState("");
    const [countryCode, setCountryCode] = useState("");
    const [logo, setLogo] = useState("");
    const [totalItems, setTotalItems] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [policyData, setPolicyData] = useState({
        name: "",
        description: "",
        type: "",
        validating: "",
        policy: {
            isExpired: false,
            expiryDate: "",
            validFrom: "",
            validTill: "",
            noExpiry: false,
            documentType: "private"
        },
        file: null,
        fileName: "",
        existingFileName: "",
        organizationId: ""
    });
    const [editCertificateId, setEditCertificateId] = useState(null);
    const [requestLoading, setRequestLoading] = useState({});
    const [dropdownOpen, setDropdownOpen] = useState(null);
    const dropdownRefs = React.useRef({});
    const [aiModal, setAiModal] = useState(false);
    const [question, setQuestion] = useState("");
    const [aiResponse, setAiResponse] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [documentToDelete, setDocumentToDelete] = useState(null);
    const [showMappingModal, setShowMappingModal] = useState(false);
    const [selectedMapping, setSelectedMapping] = useState(null);
    const [selectedDocumentDescription, setSelectedDocumentDescription] = useState(null);

    // Add bulk upload state variables
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [bulkFiles, setBulkFiles] = useState([]);
    const [isDragOver, setIsDragOver] = useState(false);
    const [bulkUploadLoading, setBulkUploadLoading] = useState(false);
    const [bulkUploadProgress, setBulkUploadProgress] = useState(0);

    // Add a ref for the file input element
    const fileInputRef = React.useRef(null);

    // Bulk delete state variables
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);

    useEffect(() => {
        getLogedInUser("", dispatch);
    }, []);

    useEffect(() => {
        if (subOrgId == undefined && id) {
            getCertificate(id, dispatch, page, limit);
        }

        if (subOrgId && id) {
            getCertificateSubOrg(id, subOrgId, dispatch);
        }
    }, [id, page, limit]);

    useEffect(() => {
        setTotalItems(certificate?.data?.pagination?.total);
        // Reset bulk selection when certificate data changes
        if (certificate?.data?.records) {
            resetBulkSelection();
        }
    }, [certificate]);

    useEffect(() => {
        setPrimaryContactName(data?.fullName);
        setEmail(data?.email);
        setPhone(data?.contact);
        setCountryCode(data?.countryCode);
        setLogo(data?.logo);
        setPolicyData(prev => ({
            ...prev,
            organizationId: id
        }));
    }, [data, id]);

    const toggleDropdown = (id) => {
        if (dropdownOpen === id) {
            setDropdownOpen(null);
        } else {
            setDropdownOpen(id);
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownOpen && dropdownRefs.current[dropdownOpen] && !dropdownRefs.current[dropdownOpen].contains(event.target)) {
                setDropdownOpen(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownOpen]);

    const handlePolicyChange = (field, value) => {
        if (field === 'noExpiry') {
            // When noExpiry is checked, clear both dates and set the flag
            setPolicyData(prev => ({
                ...prev,
                noExpiry: value,
                policy: {
                    ...prev.policy,
                    noExpiry: value,
                    // If noExpiry is checked, set dates to null
                    validFrom: value ? null : prev.policy.validFrom,
                    validTill: value ? null : prev.policy.validTill
                }
            }));
        } else if (field.startsWith('policy.')) {
            const policyField = field.split('.')[1];
            setPolicyData(prev => ({
                ...prev,
                policy: {
                    ...prev.policy,
                    [policyField]: value
                }
            }));
        } else {
            setPolicyData(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    // Update the file validation in handleFileUploadPolicy function
    const handleFileUploadPolicy = (file) => {
        if (file === null) {
            // Reset the file state
            setPolicyData(prev => ({
                ...prev,
                file: null,
                fileName: ""
            }));

            // Reset the file input element
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } else if (file) {
            // Check file type - only allow PDF and DOCX
            const extension = file.name.split('.').pop().toLowerCase();
            if (extension !== 'pdf' && extension !== 'docx' && extension !== 'png' && extension !== 'jpg' && extension !== 'jpeg') {
                toastr.error("Error", "Only PDF, DOCX, PNG, JPG, JPEG files are allowed.");

                // Reset the file input element
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
                return;
            }

            setPolicyData(prev => ({
                ...prev,
                file: file,
                fileName: file.name
            }));
        }
    }

    const handleReuploadInit = (certificate) => {
        // Format dates for date input fields
        const formatDateForInput = (dateString) => {
            if (!dateString) return "";

            try {
                const date = new Date(dateString);
                if (isValid(date)) {
                    return format(date, 'yyyy-MM-dd');
                }
            } catch (error) {
                // console.error removed
            }
            return "";
        };

        // Extract filename from document_metadata if available
        const extractFileName = (fileUrl, metadata) => {
            if (metadata?.fileName) return metadata.fileName;
            if (!fileUrl) return "";
            // Split the URL by '/' and get the last part
            const parts = fileUrl.split('/');
            return parts[parts.length - 1];
        };

        // Use organisation name if available in the nested structure
        const orgName = certificate.organisationId?.orgName || certificate.organisationName || "";

        setPolicyData({
            name: certificate.name || "",
            description: certificate.description || "",
            type: certificate.type || "",
            validating: certificate.validating || "",
            policy: {
                isExpired: certificate.policy?.isExpired || false,
                expiryDate: formatDateForInput(certificate.policy?.expiryDate),
                validFrom: formatDateForInput(certificate.policy?.validFrom),
                validTill: formatDateForInput(certificate.policy?.validTill),
                noExpiry: certificate.policy?.noExpiry || false,
                documentType: certificate.policy?.documentType || "private"
            },
            file: null,
            fileName: "",
            existingFileName: extractFileName(certificate.fileUrl, certificate.document_metadata),
            organizationId: certificate.organisationId?._id || certificate.organisationId || id
        });

        setEditCertificateId(certificate._id);

        setModal("Form Wizard modal");
    };

    const handleSubmitPolicy = () => {
        if (!policyData.name.trim()) {
            toastr.error("Error", "Organization Name is required.");
            return;
        }
        // if (!policyData.description.trim()) {
        //     toastr.error("Error", "Description is required.");
        //     return;
        // }

        if (!policyData.policy.documentType) {
            toastr.error("Error", "Document Type is required.");
            return;
        }

        // Only check expiryDate if isExpired is true and noExpiry is false
        if (policyData.policy.isExpired && !policyData.policy.noExpiry) {
            if (!policyData.policy.expiryDate) {
                toastr.error("Error", "Policy Expiry Date is required when certificate is expired.");
                return;
            }
        }

        // Only validate file upload for new certificates, not for updates
        if (!editCertificateId && !policyData.file) {
            toastr.error("Error", "Please upload a file.");
            return;
        }

        const formData = new FormData();

        // Basic fields
        formData.append('name', policyData.name);
        formData.append('description', policyData.description);
        formData.append('type', policyData.type);
        formData.append('validating', policyData.validating);
        formData.append('organisationId', policyData.organizationId);

        // Policy fields as nested properties with correct format
        formData.append('policy[isExpired]', policyData.policy.isExpired.toString());
        formData.append('policy[noExpiry]', policyData.policy.noExpiry.toString()); // Should be same as isExpired
        formData.append('policy[documentType]', policyData.policy.documentType);

        // Always append validFrom and validTill
        formData.append('policy[validFrom]', policyData.policy.validFrom);
        formData.append('policy[validTill]', policyData.policy.validTill);

        // Only append expiryDate when isExpired/noExpiry is true
        if (policyData.policy.isExpired) {
            formData.append('policy[expiryDate]', policyData.policy.expiryDate || '');
        } else {
            formData.append('policy[expiryDate]', '');
        }

        // File - only append if a new file is selected
        if (policyData.file) {
            formData.append('file', policyData.file);
        }

        if (editCertificateId) {
            formData.append('certificateId', editCertificateId);
            uploadCertificateupdate(editCertificateId, formData, dispatch, id);
        } else {
            uploadCertificate(formData, dispatch, id);
        }

        // Reset form and close modal after successful upload
        setTimeout(() => {
            resetFormFields();
            setEditCertificateId(null);
            setModal("");
        }, 100);
    };

    const resetFormFields = () => {
        setPolicyData({
            name: "",
            description: "",
            type: "",
            validating: "",
            policy: {
                isExpired: false,
                expiryDate: "",
                validFrom: "",
                validTill: "",
                noExpiry: false,
                documentType: "private"
            },
            file: null,
            fileName: "",
            existingFileName: "",
            organizationId: id
        });
        setEditCertificateId(null);

        // Reset the file input element
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleRequestPrivatePolicy = async (certificateId) => {
        // setRequestLoading(prev => ({ ...prev, [certificateId]: true }));

        const requestData = {
            parentOrganisationId: id, // Current organization ID
            subOrganisationId: subOrgId, // Use subOrgId if available, otherwise use current org
            riskMetaDataId: certificateId,
            requestingOrg: id
        };
        requestPrivatePolicy(id, dispatch, requestData, subOrgId);
    };

    const handleAskQuestion = async () => {
        if (!question.trim()) {
            toastr.error("Error", "Please enter a question");
            return;
        }

        setIsLoading(true);
        const currentQuestion = question; // Store the current question before clearing

        try {
            const payload = {
                questions: [
                    {
                        question: currentQuestion,
                        questionType: "text"
                    }
                ]
            };

            const response = await axios.post(
                `${API_URL}/tprm/${id}/answer-policy-questions`,
                payload
            );

            if (response.data && !response.data.error) {
                setAiResponse(response.data);
                setQuestion(""); // Clear the input field after successful response
            } else {
                toastr.error("Error", response.data.userMessage || "Failed to get answer");
            }
        } catch (error) {
            // console.error removed
            toastr.error("Error", "Failed to get answer");
        } finally {
            setIsLoading(false);
        }
    };

    const askMultipleChoiceQuestion = async () => {
        setIsLoading(true);

        try {
            const payload = {
                questions: [
                    {
                        question: "Do we have visibility into whether how and where the code is deployed?",
                        questionType: "singleOption",
                        questionOptions: ["Yes", "No"]
                    },
                    {
                        question: "What are the seasons of year?",
                        questionType: "multipleOption",
                        questionOptions: ["Summer", "Winter", "Rain"]
                    }
                ]
            };

            const response = await axios.post(
                `${API_URL}/api/tprm/66866ae9072369beb8721c48/answer-policy-questions`,
                payload
            );

            if (response.data && !response.data.error) {
                setAiResponse(response.data);
            } else {
                toastr.error("Error", response.data.userMessage || "Failed to get answer");
            }
        } catch (error) {
            // console.error removed
            toastr.error("Error", "Failed to get answer");
        } finally {
            setIsLoading(false);
        }
    };

    const resetAiChat = () => {
        setQuestion("");
        setAiResponse(null);
    };

    const renderAnswers = () => {
        if (!aiResponse || !aiResponse.data || !aiResponse.data.length) return null;

        return aiResponse.data.map((item, index) => {
            const questionData = aiResponse.questions ? aiResponse.questions[index] : null;

            return (
                <div key={index} className="chat-message-container">
                    {/* AI Response */}
                    <div className="chat-message ai-message">
                        <div className="message-content">
                            <div className="message-header">
                                <span className="message-sender">AI Assistant</span>
                            </div> 
                            <div className="message-text">
                                {item.questionType === "text" ? (
                                    <p>
                                        {item.hasAnswer && item.answer ? item.answer : "No content available"}
                                    </p>
                                ) : item.questionType === "singleOption" && questionData ? (
                                    <div className="option-answer">
                                        {item.hasAnswer && item.answer && item.answer.length > 0 && questionData.questionOptions
                                            ? <div className="selected-option">
                                                <i className="fa fa-check-circle mr-2"></i>
                                                {questionData.questionOptions[parseInt(item.answer[0]) - 1]}
                                            </div>
                                            : "No content available"
                                        }
                                    </div>
                                ) : item.questionType === "multipleOption" && questionData ? (
                                    <div className="option-answer">
                                        {item.hasAnswer && item.answer && item.answer.length > 0 && questionData.questionOptions ? (
                                            <ul className="selected-options">
                                                {item.answer.map((ansIndex, i) => (
                                                    <li key={i}>
                                                        <i className="fa fa-check-circle mr-2"></i>
                                                        {questionData.questionOptions[parseInt(ansIndex) - 1]}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            "No content available"
                                        )}
                                    </div>
                                ) : "No content available"}
                            </div>
                            <div className="message-time">
                                {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    };

    const handleDeleteDocument = (documentId) => {
        setDocumentToDelete(documentId);
        setShowDeleteModal(true);
    };

    const confirmDelete = () => {
        if (documentToDelete) {
            // Use bulk delete API for single document as well
            bulkDeleteDocuments([documentToDelete], id, dispatch, page, limit);
            setShowDeleteModal(false);
            setDocumentToDelete(null);
        }
    };

    // Add this function near your other helper functions
    const getCertificateClass = (certificateName) => {
        const certName = (certificateName || '').toLowerCase();
        
        if (certName.includes('iso')) return 'cert-iso';
        if (certName.includes('soc')) return 'cert-soc';
        if (certName.includes('nist')) return 'cert-nist';
        if (certName.includes('cis')) return 'cert-cis';
        if (certName.includes('gdpr')) return 'cert-gdpr';
        if (certName.includes('pci')) return 'cert-pci';
        if (certName.includes('hipaa')) return 'cert-hipaa';
        
        return 'cert-default';
    };

    const handleShowMapping = (mapping, documentDescription) => {
        setSelectedMapping(mapping);
        setShowMappingModal(true);
        setSelectedDocumentDescription(documentDescription);
    };

    // Bulk upload functions
    const handleBulkUpload = async () => {
        if (bulkFiles.length === 0) {
            toastr.error("Error", "Please select files to upload");
            return;
        }

        setBulkUploadLoading(true);
        setBulkUploadProgress(0);

        try {
            const formData = new FormData();
            
            // Append all files to the FormData
            bulkFiles.forEach((file) => {
                formData.append('files', file);
            });

            const response = await axios.post(
                `${API_URL}/tprm/organisations/${id}/security-policy-files/bulk-upload`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: (progressEvent) => {
                        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setBulkUploadProgress(progress);
                    }
                }
            );

            if (response.data && !response.data.error) {
                toastr.success("Success", `Successfully uploaded ${bulkFiles.length} files`);
                setBulkFiles([]);
                setShowBulkUploadModal(false);
                // Refresh the certificate list
                getCertificate(id, dispatch, page, limit);
            } else {
                toastr.error("Error", response.data.userMessage || "Failed to upload files");
            }
        } catch (error) {
            // console.error removed
            toastr.error("Error", error.response?.data?.userMessage || "Failed to upload files");
        } finally {
            setBulkUploadLoading(false);
            setBulkUploadProgress(0);
        }
    };

    // Drag and drop handlers
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);

        const droppedFiles = Array.from(e.dataTransfer.files);
        handleBulkFileSelection(droppedFiles);
    };

    const handleBulkFileSelection = (files) => {
        const validFiles = [];
        const invalidFiles = [];

        files.forEach(file => {
            const extension = file.name.split('.').pop().toLowerCase();
            if (extension === 'pdf' || extension === 'docx' || extension === 'png' || extension === 'jpg' || extension === 'jpeg') {
                validFiles.push(file);
            } else {
                invalidFiles.push(file.name);
            }
        });

        if (invalidFiles.length > 0) {
            toastr.warning("Warning", `The following files were skipped (only PDF and DOCX are allowed): ${invalidFiles.join(', ')}`);
        }

        if (validFiles.length > 0) {
            setBulkFiles(prev => [...prev, ...validFiles]);
        }
    };

    const handleFileInputChange = (e) => {
        const files = Array.from(e.target.files);
        handleBulkFileSelection(files);
    };

    const removeBulkFile = (index) => {
        setBulkFiles(prev => prev.filter((_, i) => i !== index));
    };

    const resetBulkUpload = () => {
        setBulkFiles([]);
        setBulkUploadProgress(0);
        setBulkUploadLoading(false);
    };

    // Bulk delete functions
    const handleSelectDocument = (documentId) => {
        setSelectedDocuments(prev => {
            if (prev.includes(documentId)) {
                return prev.filter(id => id !== documentId);
            } else {
                return [...prev, documentId];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedDocuments([]);
            setSelectAll(false);
        } else {
            const allDocumentIds = certificate?.data?.records?.map(item => item._id) || [];
            setSelectedDocuments(allDocumentIds);
            setSelectAll(true);
        }
    };

    // Update select all state when individual selections change
    useEffect(() => {
        const allDocumentIds = certificate?.data?.records?.map(item => item._id) || [];
        const allSelected = allDocumentIds.length > 0 && selectedDocuments.length === allDocumentIds.length;
        setSelectAll(allSelected);
    }, [selectedDocuments, certificate?.data?.records]);

    const handleBulkDelete = () => {
        if (selectedDocuments.length === 0) {
            toastr.error("Error", "Please select documents to delete");
            return;
        }
        setShowBulkDeleteModal(true);
    };

    const confirmBulkDelete = () => {
        if (selectedDocuments.length > 0) {
            bulkDeleteDocuments(selectedDocuments, id, dispatch, page, limit);
            setSelectedDocuments([]);
            setSelectAll(false);
            setShowBulkDeleteModal(false);
        }
    };

    const resetBulkSelection = () => {
        setSelectedDocuments([]);
        setSelectAll(false);
    };

    const MappingModal = ({ mapping, onClose, documentDescription }) => {
        if (!mapping) return null;

        return (
            <div className="modal fade mapping-modal d-block show">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                <i className="fas fa-eye mr-2"></i>
                                Certificate Control Mapping
                            </h5>
                            <button type="button" className="close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        
                        <div className="modal-body">
                            {/* Document Description Section */}
                            {documentDescription && (
                                <div className="document-description-section mb-4">
                                    <h6 className="section-title mb-3">
                                        <i className="fas fa-file-alt mr-2"></i>
                                        Document Description
                                    </h6>
                                    <div className="description-card">
                                        <p className="description-text">
                                            {documentDescription}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {/* Certificate Control Mapping Section */}
                            <div className="mapping-section">
                                <h6 className="section-title mb-3">
                                    <i className="fas fa-shield-alt mr-2"></i>
                                    Certificate Control Mapping
                                </h6>
                                <div className="mapping-table-container" style={{overflowX: 'auto', maxWidth: '100%'}}>
                                <table
                                    className="table table-bordered mapping-table mb-0"
                                    style={{ width: "100%", tableLayout: "fixed", wordBreak: "break-word", maxWidth: '100%' }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "30%", minWidth: 120, wordBreak: "break-word", whiteSpace: "pre-line", overflowWrap: 'break-word' }}>
                                                Certificate
                                            </th>
                                            <th style={{ width: "70%", wordBreak: "break-word", whiteSpace: "pre-line", overflowWrap: 'break-word' }}>
                                                Controls
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {mapping.map((item, index) => (
                                            <tr key={item._id || index}>
                                                <td
                                                    style={{
                                                        width: "30%",
                                                        minWidth: 120,
                                                        wordBreak: "break-word",
                                                        whiteSpace: "pre-line",
                                                        verticalAlign: "top",
                                                        overflowWrap: 'break-word',
                                                        maxWidth: 0
                                                    }}
                                                >
                                                    <span className={`cert-badge ${getCertificateClass(item.certificate)}`}>
                                                        {item.certificate}
                                                    </span>
                                                </td>
                                                <td
                                                    style={{
                                                        width: "70%",
                                                        wordBreak: "break-word",
                                                        whiteSpace: "pre-line",
                                                        verticalAlign: "top",
                                                        overflowWrap: 'break-word',
                                                        maxWidth: 0
                                                    }}
                                                >
                                                    <ul className="control-list" style={{ paddingLeft: 0, marginBottom: 0 }}>
                                                        {item.controls.map((control, idx) => (
                                                            <li
                                                                key={idx}
                                                                style={{
                                                                    padding: "8px 12px",
                                                                    backgroundColor: "#f8f9fa",
                                                                    borderRadius: 4,
                                                                    marginBottom: 8,
                                                                    fontSize: 14,
                                                                    color: "#495057",
                                                                    wordBreak: "break-word",
                                                                    whiteSpace: "pre-line",
                                                                    listStyle: "none",
                                                                    overflowWrap: 'break-word',
                                                                    maxWidth: '100%'
                                                                }}
                                                            >
                                                                {control}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2 className="welcome-text">Third Party Risk Management</h2>
                            <nav aria-label="breadcrumb" className="mt-1">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/vendor" className="welcome-textSmall">Third Party Risk Management</Link>
                                    </li>
                                    <li
                                        className="breadcrumb-item active"
                                        aria-current="page"
                                        style={{ color: "white" }}
                                    >
                                        Trust Panel
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12" style={{ textAlign: 'end' }}>
                            {subOrgId == undefined && (
                                <>
                                    {selectedDocuments.length > 0 && (
                                        <button
                                            type="button"
                                            className="btn btn-danger smallButtonPrimary mr-2"
                                            onClick={handleBulkDelete}
                                        >
                                            <i className="fas fa-trash mr-2" />
                                            Delete Selected ({selectedDocuments.length})
                                        </button>
                                    )}
                                    <button
                                        type="button"
                                        className="btn btn-secondary smallButtonPrimary mr-2"
                                        onClick={() => setShowBulkUploadModal(true)}
                                    >
                                        <i className="fas fa-file-import mr-2" />
                                        Bulk Upload
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary smallButtonPrimary mr-1"
                                        onClick={() => setModal("Form Wizard modal")}
                                    >
                                        <i className="fas fa-cloud-upload-alt mr-2" />
                                        Upload Documents
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* Updated AI Document Search Interface */}
                <div className="card mb-4">
                    <div className="card-body ai-search-wrapper py-4">
                        <div className="row">
                            <div className="col-12">
                                <div className="ai-search-container">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text bg-transparent border-right-0">
                                                <i className="fa fa-search text-muted"></i>
                                            </span>
                                        </div>
                                        <input 
                                            type="text" 
                                            className="form-control border-left-0" 
                                            placeholder="Ask AI a question or search documents..." 
                                            value={question}
                                            onChange={(e) => setQuestion(e.target.value)}
                                        />
                                        <div className="input-group-append">
                                            <button 
                                                className="btn btn-primary ai-button" 
                                                onClick={handleAskQuestion}
                                                disabled={isLoading}
                                            >
                                                {isLoading ? (
                                                    <>
                                                        <i className="fa fa-spinner fa-spin mr-2"></i>
                                                        Analyzing...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fa fa-robot mr-2"></i>
                                                        Ask AI
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                    
                                    {/* Display AI answers directly in the search interface */}
                                    {aiResponse && (
                                        <div className="ai-inline-response mt-4">
                                            <div className="response-card">
                                                <div className="response-header d-flex align-items-center">
                                                    <h6 className="mb-0 ml-2">AI Response</h6>
                                                    <button 
                                                        className="btn btn-sm btn-outline-secondary ml-auto"
                                                        onClick={resetAiChat}
                                                    >
                                                        <i className="fa fa-times mr-1"></i>
                                                        Clear
                                                    </button>
                                                </div>
                                                <div className="response-content">
                                                    {renderAnswers()}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                                <div className="row clearfix">
                    <div className="col-md-12">
                        <div className="card mt-2">
                            <div className="header">
                                <div className="body">
                                    {/* Empty State with Drag and Drop */}
                                    {(!certificate?.data?.records || certificate?.data?.records?.length === 0) && subOrgId == undefined ? (
                                        <div className="empty-table-container">
                                            <div 
                                                className={`table-drop-zone ${isDragOver ? 'drag-over' : ''}`}
                                                onDragOver={handleDragOver}
                                                onDragLeave={handleDragLeave}
                                                onDrop={handleDrop}
                                                onClick={() => document.getElementById('table-file-input').click()}
                                            >
                                                <input
                                                    id="table-file-input"
                                                    type="file"
                                                    multiple
                                                    accept=".pdf,.docx"
                                                    style={{ display: 'none' }}
                                                    onChange={handleFileInputChange}
                                                />
                                                
                                                <div className="empty-state-content">
                                                    <div className="empty-state-icon">
                                                        <h4>Get started by uploading your policy documents</h4>
                                                    </div>
                                                    
                                                    <div className="upload-options">
                                                        <div className="drag-drop-area">
                                                           
                                                            <h5> <i className="fas fa-cloud-upload-alt mb-3"></i>Drag & Drop Files Here</h5>
                                                            <p className="text-muted">or click to browse files</p>
                                                            <div className="supported-formats">
                                                                <small>Supported formats: PDF, DOCX</small>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="or-divider">
                                                            <span>OR</span>
                                                        </div>
                                                        
                                                        <div className="upload-buttons">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-lg upload-single-btn"
                                                                onClick={() => setModal("Form Wizard modal")}
                                                            >
                                                                <i className="fas fa-plus mr-2"></i>
                                                                Upload Single Document
                                                            </button>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Selected Files Preview in Empty State */}
                                            {bulkFiles.length > 0 && (
                                                <div className="empty-state-files mt-4">
                                                    <h6 className="section-title">
                                                        Selected Files ({bulkFiles.length})
                                                        <button
                                                            className="btn btn-sm btn-outline-secondary ml-auto"
                                                            onClick={() => setBulkFiles([])}
                                                        >
                                                            Clear All
                                                        </button>
                                                    </h6>
                                                    <div className="files-horizontal-container">
                                                        {bulkFiles.slice(0, 6).map((file, index) => (
                                                            <div key={index} className="file-card-horizontal">
                                                                <div className="file-icon-horizontal">
                                                                    {file.name.toLowerCase().endsWith('.pdf') ? (
                                                                        <i className="fas fa-file-pdf" style={{color: '#dc3545'}}></i>
                                                                    ) : (
                                                                        <i className="fas fa-file-word" style={{color: '#0d6efd'}}></i>
                                                                    )} {file.name.length > 15 ? file.name.substring(0, 100 ) + '...' : file.name}
                                                                    <button
                                                                        type="button"
                                                                        className="file-remove-horizontal"
                                                                        onClick={() => removeBulkFile(index)}
                                                                    >
                                                                    <i className="fas fa-times"></i>
                                                                </button>
                                                                </div>
                                                                
                                                                
                                                            </div>
                                                        ))}
                                                        {bulkFiles.length > 6 && (
                                                            <div className="file-card-horizontal more-files-horizontal">
                                                                <div className="more-files-text">
                                                                    <i className="fas fa-ellipsis-h"></i>
                                                                    <span>+{bulkFiles.length - 6} more</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="empty-state-actions mt-3">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={handleBulkUpload}
                                                            disabled={bulkUploadLoading}
                                                        >
                                                            {bulkUploadLoading ? (
                                                                <>
                                                                    <i className="fas fa-spinner fa-spin mr-2"></i>
                                                                    Uploading...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fas fa-upload mr-2"></i>
                                                                    Upload {bulkFiles.length} File{bulkFiles.length !== 1 ? 's' : ''}
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        /* Regular Table View */
                                        <div className="table-responsive">
                                            <table className="table table-custom spacing5 mb-0">
                                                <thead>
                                                    <tr>
                                                        {subOrgId == undefined && (
                                                            <th style={{ width: '50px' }}>
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={selectAll}
                                                                        onChange={handleSelectAll}
                                                                        id="selectAll"
                                                                    />
                                                                    <label className="form-check-label" htmlFor="selectAll"></label>
                                                                </div>
                                                            </th>
                                                        )}
                                                        <th>ID</th>
                                                        <th>Name</th>
                                                        <th>Document</th>
                                                        <th>Control Mapping</th>
                                                        <th>Details</th>
                                                        <th>Document Type</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {certificate?.data?.records?.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="6" className="text-center py-5">
                                                                <div className="no-data-message">
                                                                    <i className="fas fa-folder-open text-muted mb-3" style={{fontSize: '48px'}}></i>
                                                                    <h5 className="text-muted">No documents found</h5>
                                                                    <p className="text-muted">Start uploading documents to see them here</p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        certificate?.data?.records?.map((item, index) => (
                                                            <tr key={index}>
                                                                {subOrgId == undefined && (
                                                                    <td>
                                                                        <div className="form-check">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={selectedDocuments.includes(item._id)}
                                                                                onChange={() => handleSelectDocument(item._id)}
                                                                                id={`select-${item._id}`}
                                                                            />
                                                                            <label className="form-check-label" htmlFor={`select-${item._id}`}></label>
                                                                        </div>
                                                                    </td>
                                                                )}
                                                                <td>{item?._id}</td>
                                                                <td>{item?.name || "N/A"}</td>
                                                                <td>
                                                                    {item?.document_metadata?.signedUrl || item?.fileUrl ? (
                                                                        <a href={item?.document_metadata?.signedUrl || item?.fileUrl} 
                                                                           target="_blank" 
                                                                           rel="noopener noreferrer"
                                                                           className="d-flex align-items-center"
                                                                        >
                                                                            {(() => {
                                                                                const fileName = item?.document_metadata?.fileName || item?.fileName || "";
                                                                                const fileExt = fileName.toLowerCase().split('.').pop();
                                                                                
                                                                                if (fileExt === 'pdf') {
                                                                                    return (
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#e74c3c" className="bi bi-file-earmark-pdf mr-2" viewBox="0 0 16 16">
                                                                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                                                                                            <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"/>
                                                                                        </svg>
                                                                                    );
                                                                                } else if (fileExt === 'docx' || fileExt === 'doc') {
                                                                                    return (
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#3498db" className="bi bi-file-earmark-word mr-2" viewBox="0 0 16 16">
                                                                                            <path d="M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z"/>
                                                                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                                                                                        </svg>
                                                                                    );
                                                                                } else if (fileExt === 'xlsx' || fileExt === 'xls') {
                                                                                    return (
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#2ecc71" className="bi bi-file-earmark-excel mr-2" viewBox="0 0 16 16">
                                                                                            <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"/>
                                                                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                                                                                        </svg>
                                                                                    );
                                                                                } else if (fileExt === 'pptx' || fileExt === 'ppt') {
                                                                                    return (
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#e67e22" className="bi bi-file-earmark-ppt mr-2" viewBox="0 0 16 16">
                                                                                            <path d="M7 5.5a1 1 0 0 0-1 1V13a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5H7zM8.188 10H7V6.5h1.188a1.75 1.75 0 1 1 0 3.5z"/>
                                                                                            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>
                                                                                        </svg>
                                                                                    );
                                                                                } else {
                                                                                    return (
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#6c757d" className="bi bi-file-earmark mr-2" viewBox="0 0 16 16">
                                                                                            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>
                                                                                        </svg>
                                                                                    );
                                                                                }
                                                                            })()}
                                                                            View
                                                                        </a>
                                                                    ) : "N/A"}
                                                                </td>
                                                                <td>
                                                                    {item?.policyCertificatesAndControlsClassification && 
                                                                    item.policyCertificatesAndControlsClassification.length > 0 ? (
                                                                        <div className="cert-badges-container">
                                                                            <div className="d-flex align-items-center">
                                                                                <div className="cert-badges-wrapper">
                                                                                    {item.policyCertificatesAndControlsClassification.map((cert, idx) => (
                                                                                        <span key={cert._id || idx} 
                                                                                              className={`cert-badge ${getCertificateClass(cert.certificate)} ml-1`}
                                                                                              data-toggle="tooltip"
                                                                                              title={cert.controls?.length > 0 ? `${cert.controls.length} controls` : 'No controls'}>
                                                                                            {cert.certificate}
                                                                                        </span>
                                                                                    ))}
                                                                                </div>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <span className="text-muted">None</span>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <button 
                                                                            className="btn btn-link btn-sm mapping-icon p-0"
                                                                            onClick={() => handleShowMapping(item.policyCertificatesAndControlsClassification, item.description)}
                                                                            title="View Details"
                                                                        >
                                                                        <i className="fas fa-eye"></i>
                                                                    </button>
                                                                </td>
                                                                <td className="document-type-cell text-center">
                                                                    <div className={`document-type-badge ${item?.policy?.documentType || 'na'}`}>
                                                                        {item?.policy?.documentType ? (
                                                                            <>
                                                                                <i className={`fas ${item?.policy?.documentType === 'private' ? 'fa-lock' : 'fa-globe'}`} />
                                                                                <span>{item?.policy?.documentType === 'private' ? 'Private' : 'Public'}</span>
                                                                            </>
                                                                        ) : (
                                                                            <span className="na-text">N/A</span>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="dropdown dropdownLatestMulti" ref={el => dropdownRefs.current[item._id] = el}>
                                                                        <button type="button" className="btn p-0 dropdown-toggle-dots"
                                                                            onClick={() => toggleDropdown(item._id)}
                                                                        >
                                                                            <div className="dropDownDot">
                                                                                <div className="dropdown-dot"></div>
                                                                                <div className="dropdown-dot"></div>
                                                                                <div className="dropdown-dot"></div>
                                                                            </div>
                                                                        </button>
                                                                        <div className={`dropdown-menu ${dropdownOpen === item._id ? 'show' : ''}`}>
                                                                            {subOrgId == undefined && (
                                                                                <Link
                                                                                    className="dropdown-item dropDownDotItems"
                                                                                    to="#"
                                                                                    onClick={() => handleReuploadInit(item)}
                                                                                >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-pencil dropdown-item-icon" viewBox="0 0 16 16">
                                                                                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                                                                                    </svg>
                                                                                    Edit
                                                                                </Link>
                                                                            )}
                                                                            {subOrgId != undefined && item?.policy?.documentType === "private" && !item?.requestStatus && (
                                                                                <Link
                                                                                    className="dropdown-item dropDownDotItems"
                                                                                    to="#"
                                                                                    onClick={() => handleRequestPrivatePolicy(item._id, item.organisationId?._id)}
                                                                                >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-lock dropdown-item-icon" viewBox="0 0 16 16">
                                                                                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
                                                                                    </svg>
                                                                                    {requestLoading[item._id] ? 'Requesting...' : 'Request Access'}
                                                                                </Link>
                                                                            )}
                                                                            {item?.requestStatus && (
                                                                                <div className="dropdown-item dropDownDotItems disabled">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6563ff" className="bi bi-clock dropdown-item-icon" viewBox="0 0 16 16">
                                                                                        <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                                                                                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                                                                                    </svg>
                                                                                    {item.requestStatus === "approved" ? "Access request Approved" :
                                                                                        item.requestStatus === "rejected" ? "Access request Rejected" : "Access request Pending"}
                                                                                </div>
                                                                            )}
                                                                            {subOrgId == undefined && !item?.requestStatus && (
                                                                                <Link
                                                                                    className="dropdown-item dropDownDotItems"
                                                                                    to="#"
                                                                                    onClick={() => handleDeleteDocument(item._id)}
                                                                                >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dc3545" className="bi bi-trash dropdown-item-icon" viewBox="0 0 16 16">
                                                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                                                        <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                                                    </svg>
                                                                                    Delete
                                                                                </Link>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    
                                    <div className="d-flex justify-content-between align-content-center">
                                        <div className="dataTables_paginate">
                                            {totalItems > 0 && (
                                                <Pagination
                                                    className="pagination-bar"
                                                    currentPage={page}
                                                    totalCount={totalItems}
                                                    pageSize={limit}
                                                    onPageChange={(page) => {
                                                        setPage(page);
                                                    }}
                                                />
                                            )}
                                        </div>
                                        {totalItems > 10 && (
                                            <select
                                                value={limit}
                                                onChange={(e) => {
                                                    setLimit(e.target.value);
                                                    setPage(1);
                                                }}
                                                className="form-control limitSelectBox"
                                            >
                                                <option value={10}>10 per page</option>
                                                <option value={25}>25 per page</option>
                                                <option value={50}>50 per page</option>
                                                <option value={100}>100 per page</option>
                                            </select>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* AI Assistant Modal */}
                <div className={`modal fade AI-Modal ${aiModal ? "d-block show" : ""}`}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="fa fa-robot mr-2"></i>
                                    AI Document Assistant
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => {
                                        resetAiChat();
                                        setAiModal(false);
                                    }}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="ai-chat-container">
                                    {!aiResponse && (
                                        <div className="ai-welcome-message mb-4">
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="ai-avatar">
                                                    <i className="fa fa-robot"></i>
                                                </div>
                                                <h5 className="mb-0 ml-2">Hello! I'm your AI Document Assistant</h5>
                                            </div>
                                            <p className="text-muted">
                                                I can help you understand your documents and policies. Here are some things you can ask me:
                                            </p>
                                            <div className="suggested-questions">
                                                <button
                                                    className="btn btn-outline-primary btn-sm mr-2 mb-2"
                                                    onClick={() => setQuestion("What are the key points in our privacy policy?")}
                                                >
                                                    <i className="fa fa-shield-alt mr-1"></i> Privacy Policy Overview
                                                </button>
                                                <button
                                                    className="btn btn-outline-primary btn-sm mr-2 mb-2"
                                                    onClick={() => setQuestion("What are our security compliance requirements?")}
                                                >
                                                    <i className="fa fa-lock mr-1"></i> Security Compliance
                                                </button>
                                                <button
                                                    className="btn btn-outline-primary btn-sm mr-2 mb-2"
                                                    onClick={() => setQuestion("What are the data protection measures mentioned?")}
                                                >
                                                    <i className="fa fa-database mr-1"></i> Data Protection
                                                </button>
                                                <button
                                                    className="btn btn-outline-primary btn-sm mr-2 mb-2"
                                                    onClick={() => setQuestion("What are the document retention policies?")}
                                                >
                                                    <i className="fa fa-clock mr-1"></i> Retention Policies
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {aiResponse && (
                                        <div className="chat-response-area mb-4">
                                            <div className="response-card">
                                                <div className="response-header d-flex align-items-center">
                                                    <div className="ai-avatar">
                                                        <i className="fa fa-robot"></i>
                                                    </div>
                                                    <h6 className="mb-0 ml-2">AI Response</h6>
                                                </div>
                                                <div className="response-content">
                                                    {renderAnswers()}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="chat-input-wrapper">
                                        <div className="chat-input-area">
                                            <textarea
                                                className="form-control ai-textarea"
                                                rows={3}
                                                value={question}
                                                onChange={(e) => setQuestion(e.target.value)}
                                                placeholder="Ask me anything about your documents and policies..."
                                            />
                                            <div className="ai-buttons mt-3">
                                                <button
                                                    className="btn btn-primary ai-ask-btn"
                                                    onClick={handleAskQuestion}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? (
                                                        <>
                                                            <i className="fa fa-spinner fa-spin mr-2"></i>
                                                            Analyzing...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa fa-paper-plane mr-2"></i>
                                                            Ask Question
                                                        </>
                                                    )}
                                                </button>
                                                <button
                                                    className="btn btn-outline-secondary ai-clear-btn ml-2"
                                                    onClick={resetAiChat}
                                                    disabled={isLoading || (!question && !aiResponse)}
                                                >
                                                    <i className="fa fa-refresh mr-2"></i>
                                                    Start Over
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Document Upload Modal */}
                <div 
                    key={isModal === "Form Wizard modal" ? "open" : "closed"}
                    className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""}`}
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="fa fa-upload mr-2"></i>
                                    {editCertificateId ? "Update Document" : "Upload New Document"}
                                </h5>
                                <button type="button" className="close" onClick={() => {
                                    resetFormFields();
                                    setModal("");
                                }}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="upload-form">
                                    <div className="form-section mb-4">
                                        <h6 className="section-title mb-3">Document Information</h6>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Document Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={policyData.name}
                                                    onChange={(e) => handlePolicyChange('name', e.target.value)}
                                                    placeholder="Enter document name"
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Document Type</label>
                                                <div className="document-type-selector">
                                                    <div className="document-type-item" 
                                                         onClick={() => handlePolicyChange('policy.documentType', 'private')}
                                                         style={{ 
                                                             backgroundColor: policyData.policy.documentType === 'private' ? '#e3f2fd' : 'transparent',
                                                             border: policyData.policy.documentType === 'private' ? '2px solid #2196f3' : '1px solid #ddd'
                                                         }}>
                                                        <i className="fas fa-lock"></i>
                                                        <span>Private Document</span>
                                                    </div>
                                                    <div className="document-type-item" 
                                                         onClick={() => handlePolicyChange('policy.documentType', 'public')}
                                                         style={{ 
                                                             backgroundColor: policyData.policy.documentType === 'public' ? '#e8f5e9' : 'transparent',
                                                             border: policyData.policy.documentType === 'public' ? '2px solid #4caf50' : '1px solid #ddd'
                                                         }}>
                                                        <i className="fas fa-globe"></i>
                                                        <span>Public Document</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-section mb-4">
                                        <h6 className="section-title mb-3">Validity Period</h6>
                                        <div className="mb-3">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="noExpiry"
                                                    checked={policyData.policy.noExpiry}
                                                    onChange={(e) => handlePolicyChange('noExpiry', e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="noExpiry">
                                                    No Expiry (Document does not expire)
                                                </label>
                                            </div>
                                        </div>

                                        {/* Only show date fields if No Expiry is NOT checked */}
                                        {!policyData.policy.noExpiry && (
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Valid From</label>
                                                    <DatePicker
                                                        selected={policyData.policy.validFrom ? new Date(policyData.policy.validFrom) : null}
                                                        onChange={(date) => handlePolicyChange('policy.validFrom', date ? format(date, 'yyyy-MM-dd') : null)}
                                                        className="form-control"
                                                        dateFormat="MMM d, yyyy"
                                                        placeholderText="Select start date"
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Valid Until</label>
                                                    <DatePicker
                                                        selected={policyData.policy.validTill ? new Date(policyData.policy.validTill) : null}
                                                        onChange={(date) => handlePolicyChange('policy.validTill', date ? format(date, 'yyyy-MM-dd') : null)}
                                                        className="form-control"
                                                        dateFormat="MMM d, yyyy"
                                                        placeholderText="Select end date"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="form-section mb-4">
                                        {/* <h6 className="section-title mb-3">Document Description</h6>
                                        <div className="mb-3">
                                            <textarea
                                                className="form-control"
                                                rows={4}
                                                value={policyData.description}
                                                onChange={(e) => handlePolicyChange('description', e.target.value)}
                                                placeholder="Enter document description"
                                            />
                                        </div> */}
                                    </div>

                                    <div className="form-section">
                                        <h6 className="section-title mb-3">Upload Document</h6>
                                        <div className="upload-container">
                                            <div className="upload-box">
                                                <input
                                                    type="file"
                                                    id="file-upload"
                                                    className="file-input"
                                                    onChange={(e) => handleFileUploadPolicy(e.target.files[0])}
                                                    accept=".pdf,.docx,.png,.jpg,.jpeg"
                                                    ref={fileInputRef}
                                                />
                                                <div className="upload-content">
                                                    {policyData.fileName && (
                                                        <div className="selected-file-wrapper">
                                                            <div className="selected-file">
                                                                <i className="fa fa-file-alt"></i>
                                                                <span className="file-name">{policyData.fileName}</span>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-link btn-sm remove-file"
                                                                    onClick={() => handleFileUploadPolicy(null)}
                                                                >
                                                                    <i className="fa fa-times"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="supported-formats">
                                                        <small>Supported formats: PDF, DOCX, PNG, JPG, JPEG</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={() => {
                                        resetFormFields();
                                        setModal("");
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSubmitPolicy}
                                >
                                    {editCertificateId ? "Update Document" : "Upload Document"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Delete Confirmation Modal */}
                <div className={`modal fade delete-modal ${showDeleteModal ? "d-block show" : ""}`}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Confirm Delete
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => {
                                        setShowDeleteModal(false);
                                        setDocumentToDelete(null);
                                    }}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p style={{ fontSize: "15px" }} className="mb-0">Are you sure you want to delete this document? This action cannot be undone.</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn  btn-default"
                                    onClick={() => {
                                        setShowDeleteModal(false);
                                        setDocumentToDelete(null);
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={confirmDelete}
                                >
                                    Delete Document
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {showMappingModal && (
                    <MappingModal 
                        mapping={selectedMapping} 
                        documentDescription={selectedDocumentDescription}
                        onClose={() => {
                            setShowMappingModal(false);
                            setSelectedMapping(null);
                            setSelectedDocumentDescription(null);
                        }} 
                    />
                )}

                {/* Bulk Delete Confirmation Modal */}
                <div className={`modal fade bulk-delete-modal ${showBulkDeleteModal ? "d-block show" : ""}`}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="fas fa-exclamation-triangle text-warning mr-2"></i>
                                    Confirm Bulk Delete
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => setShowBulkDeleteModal(false)}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="alert alert-warning">
                                    <i className="fas fa-exclamation-triangle mr-2"></i>
                                    <strong>Warning:</strong> You are about to delete {selectedDocuments.length} document(s). This action cannot be undone.
                                </div>
                                <p className="mb-0">Are you sure you want to proceed with the deletion?</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowBulkDeleteModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={confirmBulkDelete}
                                >
                                    <i className="fas fa-trash mr-2"></i>
                                    Delete {selectedDocuments.length} Document(s)
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bulk Upload Modal */}
                <div className={`modal fade bulk-upload-modal ${showBulkUploadModal ? "d-block show" : ""}`}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="fas fa-file-import mr-2"></i>
                                    Bulk Upload Documents
                                </h5>
                                <button 
                                    type="button" 
                                    className="close" 
                                    onClick={() => {
                                        setShowBulkUploadModal(false);
                                        resetBulkUpload();
                                    }}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            
                            <div className="modal-body">
                                <div className="bulk-upload-container">
                                    <div className="upload-instructions mb-4">
                                        <div className="alert alert-info">
                                            <i className="fas fa-info-circle mr-2"></i>
                                            <strong>Instructions:</strong> Drag and drop multiple PDF or DOCX files, or click to browse. 
                                            All files will be uploaded as private documents.
                                        </div>
                                    </div>

                                    {/* Drag and Drop Area */}
                                    <div 
                                        className={`bulk-drop-zone ${isDragOver ? 'drag-over' : ''} ${bulkFiles.length > 0 ? 'has-files' : ''}`}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                        onClick={() => document.getElementById('bulk-file-input').click()}
                                    >
                                        <input
                                            id="bulk-file-input"
                                            type="file"
                                            multiple
                                            accept=".pdf,.docx"
                                            style={{ display: 'none' }}
                                            onChange={handleFileInputChange}
                                        />
                                        
                                        <div className="drop-zone-content">
                                            <div className="drop-zone-icon">
                                                <i className="fas fa-cloud-upload-alt"></i>
                                            </div>
                                            <h5>Drag & Drop Files Here</h5>
                                            <p className="text-muted">or click to browse</p>
                                            <div className="supported-formats">
                                                <small>Supported formats: PDF, DOCX</small>
                                            </div>
                                        </div>
                                    </div>

                                    {/* File List */}
                                    {bulkFiles.length > 0 && (
                                        <div className="selected-files-section mt-4">
                                            <h6 className="section-title">
                                                Selected Files ({bulkFiles.length})
                                            </h6>
                                            <div className="selected-files-list">
                                                {bulkFiles.map((file, index) => (
                                                    <div key={index} >
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div className="">
                                                                {file.name.toLowerCase().endsWith('.pdf') ? (
                                                                    <i className="fas fa-file-pdf text-danger"></i>
                                                                ) : (
                                                                    <i className="fas fa-file-word text-primary"></i>
                                                                )}
                                                            </div>
                                                            <div className="file-details">
                                                                <div className="file-name">{file.name}</div>
                                                                <div className="file-size text-muted">
                                                                    {(file.size / 1024 / 1024).toFixed(2)} MB
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-link btn-sm remove-file-btn"
                                                            onClick={() => removeBulkFile(index)}
                                                            disabled={bulkUploadLoading}
                                                        >
                                                            <i className="fas fa-times"></i>
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Upload Progress */}
                                    {bulkUploadLoading && (
                                        <div className="upload-progress-section mt-4">
                                            <h6 className="section-title">Uploading Files...</h6>
                                            <div className="progress">
                                                <div 
                                                    className="progress-bar progress-bar-striped progress-bar-animated" 
                                                    role="progressbar" 
                                                    style={{ width: `${bulkUploadProgress}%` }}
                                                    aria-valuenow={bulkUploadProgress} 
                                                    aria-valuemin="0" 
                                                    aria-valuemax="100"
                                                >
                                                    {bulkUploadProgress}%
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowBulkUploadModal(false);
                                        resetBulkUpload();
                                    }}
                                    disabled={bulkUploadLoading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleBulkUpload}
                                    disabled={bulkFiles.length === 0 || bulkUploadLoading}
                                >
                                    {bulkUploadLoading ? (
                                        <>
                                            <i className="fas fa-spinner fa-spin mr-2"></i>
                                            Uploading...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-upload mr-2"></i>
                                            Upload {bulkFiles.length} File{bulkFiles.length !== 1 ? 's' : ''}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

<style>
    {`
    .hide-default-icon::-webkit-calendar-picker-indicator {
        display: none;
    }
    
    .position-relative {
        position: relative;
    }
    
    .calendar-icon {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        z-index: 1;
    }
    
    .dropdown-toggle-dots {
        background-color: transparent;
        border: none;
        cursor: pointer;
    }
    
    .dropDownDot {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 20px;
    }
    
    .dropdown-dot {
        width: 4px;
        height: 4px;
        background-color: #6563ff;
        border-radius: 50%;
        margin: 1px 0;
    }
    
    .dropdownLatestMulti {
        position: relative;
    }
    
    .dropdownLatestMulti .dropdown-menu {
        right: 0;
        left: auto;
        min-width: 180px;
    }
    
    .dropDownDotItems {
        display: flex;
        align-items: center;
        padding: 8px 16px;
    }
    
    .dropdown-item-icon {
        margin-right: 8px;
    }
    
    .disabled {
        color: #6c757d;
        pointer-events: none;
        background-color: transparent;
    }

    .ai-modal-header {
        background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
        color: white;
        border-bottom: none;
    }
    
    .ai-modal-header .close {
        color: white;
        opacity: 0.8;
        text-shadow: none;
    }
    
    .ai-modal-header .close:hover {
        opacity: 1;
    }
    
    .ai-modal-body {
        padding: 25px;
        background-color: #f9f9f9;
    }
    
    .ai-chat-container {
        display: flex;
        flex-direction: column;
    }
    
    .ai-welcome-message {
        background-color: white;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        border-left: 4px solid #6563ff;
    }
    
    .ai-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 18px;
    }
    
    .chat-response-area {
        max-height: 350px;
        overflow-y: auto;
        padding-right: 5px;
    }
    
    .chat-response-area::-webkit-scrollbar {
        width: 6px;
    }
    
    .chat-response-area::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }
    
    .chat-response-area::-webkit-scrollbar-thumb {
        background: #6563ff;
        border-radius: 10px;
    }
    
    .response-card {
        background-color: white;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    }
    
    .response-header {
        padding-bottom: 15px;
        margin-bottom: 15px;
        border-bottom: 1px solid #eee;
    }
    
    .response-content {
        color: #333;
    }
    
    .chat-input-wrapper {
        background-color: white;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    }
    
    .ai-textarea {
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        transition: border-color 0.3s, box-shadow 0.3s;
        resize: none;
    }
    
    .ai-textarea:focus {
        border-color: #6563ff;
        box-shadow: 0 0 0 0.2rem rgba(101, 99, 255, 0.25);
    }
    
    .ai-buttons {
        display: flex;
        gap: 10px;
    }
    
    .ai-ask-btn {
        background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
        border: none;
        border-radius: 8px;
        padding: 8px 20px;
        box-shadow: 0 2px 5px rgba(101, 99, 255, 0.3);
        transition: all 0.3s;
    }
    
    .ai-ask-btn:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(101, 99, 255, 0.4);
    }
    
    .ai-sample-btn {
        border-radius: 8px;
        border-color: #6563ff;
        color: #6563ff;
        padding: 8px 20px;
        transition: all 0.3s;
    }
    
    .ai-sample-btn:hover:not(:disabled) {
        background-color: #f0f0ff;
    }
    
    .ai-clear-btn {
        border-radius: 8px;
        padding: 8px 20px;
        transition: all 0.3s;
    }
    
    .ai-answer-item {
        margin-bottom: 25px;
    }
    
    .question-bubble {
        margin-bottom: 15px;
    }
    
    .question-header {
        display: flex;
        align-items: center;
        padding: 10px 15px;
        background-color: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;
    }
    
    .question-text {
        font-weight: 500;
        color: #495057;
    }
    
    .answer-bubble {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 15px;
        border: 1px solid #e9ecef;
    }
    
    .answer-header {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e9ecef;
    }
    
    .ai-avatar-small {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        margin-right: 10px;
    }
    
    .answer-title {
        font-weight: 500;
        color: #495057;
    }
    
    .answer-content {
        padding: 10px 0;
    }
    
    .answer-text {
        margin-bottom: 0;
        line-height: 1.6;
        color: #495057;
    }
    
    .option-answer {
        background-color: white;
        border-radius: 6px;
        padding: 10px;
        margin-top: 5px;
    }
    
    .answer-list {
        list-style: none;
        padding-left: 0;
        margin-bottom: 0;
    }
    
    .answer-list-item {
        padding: 8px 12px;
        background-color: #f8f9fa;
        border-radius: 4px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
    }
    
    .answer-list-item:last-child {
        margin-bottom: 0;
    }
    
    .text-muted {
        color: #6c757d;
        display: flex;
        align-items: center;
    }

    /* AI Assistant Styles */
    .ai-chat-container {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .ai-welcome-message {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 20px;
    }

    .ai-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
    }

    .suggested-questions {
        display: flex;
        flex-wrap: wrap;
        margin-top: 15px;
    }

    .suggested-questions .btn {
        border-radius: 20px;
        padding: 8px 16px;
    }

    .chat-response-area {
        max-height: 300px;
        overflow-y: auto;
        padding-right: 10px;
    }

    .response-card {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 15px;
    }

    .response-header {
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid #dee2e6;
    }

    .chat-input-wrapper {
        margin-top: auto;
    }

    .ai-textarea {
        border-radius: 8px;
        resize: none;
    }

    .ai-buttons {
        display: flex;
        gap: 10px;
    }

    /* Document Upload Styles */
    .upload-form {
        padding: 20px;
    }

    .form-section {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 20px;
    }

    .section-title {
        color: #2c3e50;
        font-weight: 500;
        font-size: 16px;
    }

    .form-label {
        color: #495057;
        font-weight: 500;
        margin-bottom: 8px;
    }

    .form-control {
        border-radius: 6px;
        border: 1px solid #e9ecef;
        padding: 8px 12px;
    }

    .form-control:focus {
        border-color: #6563ff;
        box-shadow: 0 0 0 0.2rem rgba(101, 99, 255, 0.25);
    }

    .upload-container {
        padding: 20px;
    }

    .upload-box {
        position: relative;
        border: 2px dashed #dee2e6;
        border-radius: 8px;
        background-color: #f8f9fa;
        transition: all 0.3s ease;
        padding: 30px;
    }

    .upload-box:hover {
        border-color: #6563ff;
        background-color: #f0f2ff;
    }

    .file-input {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }

    .upload-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }

    .upload-icon-wrapper {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background-color: #e9ecef;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
    }

    .upload-icon-wrapper i {
        font-size: 32px;
        color: #6563ff;
    }

    .upload-text-wrapper {
        text-align: center;
    }

    .upload-text-wrapper h5 {
        color: #2c3e50;
        font-size: 18px;
        margin-bottom: 8px;
    }

    .upload-text-wrapper .text-muted {
        color: #6c757d;
        margin-bottom: 12px;
    }

    .upload-button {
        background-color: #6563ff;
        color: white;
        padding: 8px 20px;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s;
        display: inline-flex;
        align-items: center;
        font-weight: 500;
    }

    .upload-button:hover {
        background-color: #5654e6;
        text-decoration: none;
        transform: translateY(-1px);
    }

    .selected-file-wrapper {
        width: 100%;
        max-width: 400px;
    }

    .selected-file {
        background-color: white;
        border: 1px solid #e9ecef;
        border-radius: 6px;
        padding: 12px 15px;
        display: flex;
        align-items: center;
        gap: 12px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }

    .selected-file i {
        color: #6563ff;
        font-size: 18px;
    }

    .selected-file .file-name {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #2c3e50;
    }

    .remove-file {
        color: #dc3545;
        padding: 0;
        margin-left: auto;
        opacity: 0.7;
        transition: opacity 0.3s;
    }

    .remove-file:hover {
        color: #c82333;
        opacity: 1;
    }

    .supported-formats {
        color: #6c757d;
        font-size: 12px;
        margin-top: 10px;
    }

    .delete-modal {
        background-color: rgba(0, 0, 0, 0.5);
    }

    .delete-modal .modal-content {
        border: none;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    .delete-modal .modal-header {
        border-bottom: 1px solid #e9ecef;
        padding: 1rem 1.5rem;
    }

    .delete-modal .modal-title {
        display: flex;
        align-items: center;
        color: #2d3748;
        font-size: 1.25rem;
    }

    .delete-modal .modal-body {
        padding: 1.5rem;
        color: #4a5568;
        font-size: 1rem;
    }

    .delete-modal .modal-footer {
        border-top: 1px solid #e9ecef;
        padding: 1rem 1.5rem;
    }

    .delete-modal .btn-secondary {
        background-color: #e2e8f0;
        border: none;
        color: #4a5568;
        padding: 0.5rem 1rem;
        font-weight: 500;
        transition: all 0.2s;
    }

    .delete-modal .btn-secondary:hover {
        background-color: #cbd5e0;
    }

    .delete-modal .btn-danger {
        background-color: #f56565;
        border: none;
        padding: 0.5rem 1rem;
        font-weight: 500;
        transition: all 0.2s;
    }

    .delete-modal .btn-danger:hover {
        background-color: #e53e3e;
    }

    .delete-modal .close {
        color: #a0aec0;
        opacity: 1;
        transition: all 0.2s;
    }

    .delete-modal .close:hover {
        color: #4a5568;
    }

    .mapping-modal {
        background-color: rgba(0, 0, 0, 0.5);
    }

    .mapping-modal .modal-dialog {
        max-width: 800px;
        margin: 1.75rem auto;
        height: calc(100vh - 3.5rem);
        display: flex;
        align-items: center;
    }

    .mapping-modal .modal-content {
        border: none;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        max-height: calc(100vh - 3.5rem);
        display: flex;
        flex-direction: column;
    }

    .mapping-modal .modal-header {
        background-color: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
        padding: 1rem 1.5rem;
        flex-shrink: 0;
    }

    .mapping-modal .modal-body {
        flex: 1;
        overflow: hidden;
        position: relative;
    }

    .mapping-modal .modal-footer {
        border-top: 1px solid #e9ecef;
        padding: 1rem 1.5rem;
        flex-shrink: 0;
    }

    .mapping-table-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
        padding: 1.5rem;
    }

    .mapping-table {
        width: 100%;
        table-layout: fixed;
    }

    .mapping-table th {
        background-color: #f8f9fa;
        position: sticky;
        top: 0;
        z-index: 1;
        white-space: nowrap;
    }

    .certificate-column {
        width: 30%;
        min-width: 150px;
    }

    .controls-column {
        width: 70%;
    }

    .mapping-table td {
        vertical-align: middle;
    }

    .control-list {
        list-style: none;
        padding-left: 0;
        margin-bottom: 0;
    }

    .control-list li {
        padding: 8px 12px;
        background-color: #f8f9fa;
        border-radius: 4px;
        margin-bottom: 8px;
        font-size: 14px;
        color: #495057;
        word-break: break-word;
    }

    .control-list li:last-child {
        margin-bottom: 0;
    }

    .mapping-icon {
        color: #6563ff;
        padding: 4px;
        font-size: 16px;
        transition: all 0.3s ease;
        margin-left: 8px;
    }

    .mapping-icon:hover {
        color: #4834d4;
        transform: scale(1.1);
    }

    .cert-badge {
        display: inline-flex;
        align-items: center;
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 500;
        color: white;
        white-space: nowrap;
    }

    .cert-badge.cert-nist {
        background-color: #2c3e50;
    }

    .cert-badge.cert-iso {
        background-color: #27ae60;
    }

    .cert-badge.cert-soc {
        background-color: #e67e22;
    }

    .cert-badge.cert-cis {
        background-color: #3498db;
    }

    .cert-badge.cert-gdpr {
        background-color: #9b59b6;
    }

    .cert-badge.cert-pci {
        background-color: #e74c3c;
    }

    .cert-badge.cert-hipaa {
        background-color: #34495e;
    }

    .cert-badge.cert-default {
        background-color: #95a5a6;
    }

    /* Description column styles */
    .description-cell {
        max-width: 300px;
        word-wrap: break-word;
    }

    .description-content {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .description-text {
        font-size: 14px;
        line-height: 1.4;
        color: #495057;
        margin-bottom: 0;
        word-break: break-word;
        white-space: pre-line;
    }

    .description-text:not(:last-child) {
        margin-bottom: 5px;
    }

    .btn-link.btn-sm {
        font-size: 12px;
        padding: 0;
        text-decoration: none;
        border: none;
        background: none;
        color: #007bff;
        cursor: pointer;
    }

    .btn-link.btn-sm:hover {
        color: #0056b3;
        text-decoration: underline;
    }

    /* Document Description Modal Styles */
    .document-description-section {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 20px;
    }

    .section-title {
        color: #2c3e50;
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 15px;
    }

    .description-card {
        background-color: white;
        border-radius: 6px;
        padding: 15px;
        border: 1px solid #e9ecef;
    }

    .description-text {
        font-size: 14px;
        line-height: 1.6;
        color: #495057;
        margin-bottom: 0;
        word-break: break-word;
        white-space: pre-line;
    }

    .mapping-section {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 20px;
    }

    /* Bulk Upload Modal Styles */
    .bulk-upload-modal {
        background-color: rgba(0, 0, 0, 0.5);
    }

    .bulk-upload-modal .modal-content {
        border: none;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    .bulk-upload-modal .modal-header {
        background-color: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
        padding: 1rem 1.5rem;
    }

    .bulk-upload-container {
        padding: 20px;
    }

    .upload-instructions .alert {
        border-radius: 8px;
        border: none;
        background-color: #d1ecf1;
        color: #0c5460;
    }

    .bulk-drop-zone {
        border: 2px dashed #dee2e6;
        border-radius: 12px;
        padding: 60px 20px;
        text-align: center;
        background-color: #f8f9fa;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .bulk-drop-zone:hover {
        border-color: #6563ff;
        background-color: #f0f2ff;
    }

    .bulk-drop-zone.drag-over {
        border-color: #6563ff;
        background-color: #e3f2fd;
        border-style: solid;
        box-shadow: 0 0 20px rgba(101, 99, 255, 0.2);
    }

    .bulk-drop-zone.has-files {
        min-height: 120px;
        padding: 30px 20px;
    }

    .drop-zone-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
    }

    .drop-zone-icon {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: #e9ecef;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
    }

    .drop-zone-icon i {
        font-size: 36px;
        color: #6563ff;
    }

    .bulk-drop-zone h5 {
        color: #2c3e50;
        font-size: 20px;
        margin-bottom: 5px;
    }

    .bulk-drop-zone .text-muted {
        color: #6c757d;
        margin-bottom: 10px;
    }

    .selected-files-section {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 20px;
    }

    .selected-files-list {
        max-height: 300px;
        overflow-y: auto;
    }

    .selected-files-list::-webkit-scrollbar {
        width: 6px;
    }

    .selected-files-list::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }

    .selected-files-list::-webkit-scrollbar-thumb {
        background: #6563ff;
        border-radius: 10px;
    }

    .file-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        background-color: white;
        border-radius: 8px;
        margin-bottom: 10px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        transition: all 0.3s ease;
    }

    .file-item:hover {
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    }

    .file-item:last-child {
        margin-bottom: 0;
    }

    .file-info {
        display: flex;
        align-items: center;
        gap: 15px;
        flex: 1;
    }

    .file-icon {
        font-size: 24px;
        width: 40px;
        text-align: center;
    }

    .file-details {
        flex: 1;
    }

    .file-name {
        font-weight: 500;
        color: #2c3e50;
        margin-bottom: 4px;
        word-break: break-word;
    }

    .file-size {
        font-size: 13px;
        color: #6c757d;
    }

    .remove-file-btn {
        color: #dc3545;
        padding: 5px 10px;
        font-size: 16px;
        opacity: 0.7;
        transition: all 0.3s ease;
    }

    .remove-file-btn:hover {
        color: #c82333;
        opacity: 1;
        transform: scale(1.1);
    }

    .upload-progress-section {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 20px;
    }

    .upload-progress-section .progress {
        height: 20px;
        border-radius: 10px;
        background-color: #e9ecef;
    }

    .upload-progress-section .progress-bar {
        background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
        border-radius: 10px;
        font-size: 14px;
        font-weight: 500;
    }

    .bulk-upload-modal .modal-footer {
        border-top: 1px solid #e9ecef;
        padding: 1rem 1.5rem;
    }

    .bulk-upload-modal .btn-secondary {
        background-color: #e2e8f0;
        border: none;
        color: #4a5568;
        padding: 0.5rem 1rem;
        font-weight: 500;
        transition: all 0.2s;
    }

    .bulk-upload-modal .btn-secondary:hover {
        background-color: #cbd5e0;
    }

    .bulk-upload-modal .btn-primary {
        background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
        border: none;
        padding: 0.5rem 1rem;
        font-weight: 500;
        transition: all 0.2s;
    }

    .bulk-upload-modal .btn-primary:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(101, 99, 255, 0.3);
    }

    .bulk-upload-modal .btn-primary:disabled {
        background-color: #cbd5e0;
        opacity: 0.6;
    }

         /* Enhanced Empty State Drag & Drop Styles */
     .empty-table-container {
         padding: 50px 30px;
         text-align: center;
         background: linear-gradient(135deg, #f8fafe 0%, #f1f7ff 100%);
         border-radius: 16px;
         margin: 20px 0;
     }

     .table-drop-zone {
         border: 3px dashed #c7d2fe;
         border-radius: 20px;
         padding: 60px 30px;
         background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
         cursor: pointer;
         transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
         position: relative;
         min-height: 400px;
         display: flex;
         align-items: center;
         justify-content: center;
         box-shadow: 0 4px 25px rgba(101, 99, 255, 0.08);
         overflow: hidden;
     }

     .table-drop-zone::before {
         content: '';
         position: absolute;
         top: -50%;
         left: -50%;
         width: 200%;
         height: 200%;
         background: radial-gradient(circle, rgba(101, 99, 255, 0.05) 0%, transparent 70%);
         opacity: 0;
         transition: opacity 0.4s ease;
         z-index: 0;
     }

     .table-drop-zone:hover {
         border-color: #6563ff;
         background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
         transform: translateY(-4px);
         box-shadow: 0 12px 40px rgba(101, 99, 255, 0.15);
     }

     .table-drop-zone:hover::before {
         opacity: 1;
     }

     .table-drop-zone.drag-over {
         border-color: #6563ff;
         border-style: solid;
         background: linear-gradient(135deg, #f0f2ff 0%, #e8ebff 100%);
         box-shadow: 0 20px 60px rgba(101, 99, 255, 0.25);
         transform: scale(1.02);
         animation: pulse 2s infinite;
     }

     @keyframes pulse {
         0%, 100% { box-shadow: 0 20px 60px rgba(101, 99, 255, 0.25); }
         50% { box-shadow: 0 20px 60px rgba(101, 99, 255, 0.35); }
     }

     .empty-state-content {
         width: 100%;
         max-width: 700px;
         z-index: 2;
         position: relative;
     }

     .empty-state-icon {
         width: 120px;
         height: 120px;
         border-radius: 50%;
         background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
         display: flex;
         align-items: center;
         justify-content: center;
         margin: 0 auto 30px;
         box-shadow: 0 8px 32px rgba(101, 99, 255, 0.3);
         animation: float 6s ease-in-out infinite;
         position: relative;
     }

     @keyframes float {
         0%, 100% { transform: translateY(0px); }
         50% { transform: translateY(-10px); }
     }

     .empty-state-icon::after {
         content: '';
         position: absolute;
         top: -10px;
         left: -10px;
         right: -10px;
         bottom: -10px;
         border-radius: 50%;
         background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
         opacity: 0.3;
         animation: ripple 3s infinite;
         z-index: -1;
     }

     @keyframes ripple {
         0% { transform: scale(1); opacity: 0.3; }
         100% { transform: scale(1.2); opacity: 0; }
     }

     .empty-state-icon i {
         font-size: 56px;
         color: white;
         z-index: 2;
         position: relative;
     }

     .empty-state-content h4 {
         color: #2d3748;
         font-size: 32px;
         font-weight: 700;
         margin-bottom: 16px;
         line-height: 1.3;
         text-shadow: 0 1px 3px rgba(0,0,0,0.1);
     }

     .empty-state-content .text-muted {
         color: #718096 !important;
         font-size: 18px;
         line-height: 1.6;
         max-width: 500px;
         margin: 0 auto 40px;
     }

     .upload-options {
         margin-top: 50px;
     }

     .drag-drop-area {
         background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
         border: 2px dashed #cbd5e0;
         border-radius: 16px;
         padding: 50px 30px;
         margin-bottom: 40px;
         box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
         transition: all 0.3s ease;
         position: relative;
     }

     .drag-drop-area:hover {
         border-color: #6563ff;
         background: linear-gradient(135deg, #f0f2ff 0%, #e8ebff 100%);
         transform: translateY(-2px);
         box-shadow: 0 8px 25px rgba(101, 99, 255, 0.1), inset 0 2px 4px rgba(0,0,0,0.05);
     }

     .drag-drop-area i {
         font-size: 48px;
         color: #6563ff;
         margin-bottom: 20px;
         animation: bounce 2s ease-in-out infinite;
     }

     @keyframes bounce {
         0%, 100% { transform: translateY(0px); }
         50% { transform: translateY(-8px); }
     }

     .drag-drop-area h5 {
         color: #2d3748;
         font-size: 24px;
         margin-bottom: 12px;
         font-weight: 600;
     }

     .drag-drop-area .text-muted {
         color: #718096 !important;
         font-size: 16px;
         margin-bottom: 20px;
     }

     .supported-formats {
         display: inline-flex;
         align-items: center;
         gap: 12px;
         background: white;
         padding: 12px 20px;
         border-radius: 50px;
         box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
         border: 1px solid #e2e8f0;
     }

     .supported-formats::before {
         content: '📄';
         font-size: 16px;
         margin-right: 8px;
     }

     .supported-formats small {
         color: #4a5568;
         font-weight: 500;
         font-size: 14px;
     }

     .or-divider {
         position: relative;
         margin: 40px 0;
         display: flex;
         align-items: center;
         justify-content: center;
     }

     .or-divider span {
         background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
         color: white;
         padding: 8px 24px;
         border-radius: 25px;
         font-weight: 600;
         font-size: 14px;
         text-transform: uppercase;
         letter-spacing: 0.5px;
         box-shadow: 0 4px 12px rgba(101, 99, 255, 0.3);
         position: relative;
         z-index: 2;
     }

     .or-divider::before {
         content: '';
         position: absolute;
         top: 50%;
         left: 0;
         right: 0;
         height: 2px;
         background: linear-gradient(90deg, transparent 0%, #e2e8f0 20%, #e2e8f0 80%, transparent 100%);
         z-index: 1;
     }

     .upload-buttons {
         display: grid;
         grid-template-columns: 1fr 1fr;
         gap: 20px;
         max-width: 600px;
         margin: 0 auto;
     }

     .upload-single-btn,
     .upload-bulk-btn {
         padding: 18px 30px;
         font-size: 16px;
         font-weight: 600;
         border-radius: 12px;
         transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
         position: relative;
         overflow: hidden;
         display: flex;
         align-items: center;
         justify-content: center;
         gap: 12px;
         text-transform: none;
         box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
     }

     .upload-single-btn {
         background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
         border: none;
         color: white;
     }

     .upload-bulk-btn {
         background: white;
         border: 2px solid #6563ff;
         color: #6563ff;
     }

     .upload-single-btn:hover,
     .upload-bulk-btn:hover {
         transform: translateY(-3px);
         box-shadow: 0 8px 25px rgba(101, 99, 255, 0.25);
     }

     .upload-single-btn:hover {
         box-shadow: 0 8px 25px rgba(101, 99, 255, 0.4);
     }

     .upload-bulk-btn:hover {
         background: linear-gradient(135deg, #f0f2ff 0%, #e8ebff 100%);
         border-color: #4834d4;
         color: #4834d4;
     }

     .empty-state-files {
         background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
         border-radius: 20px;
         padding: 30px;
         box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
         border: 1px solid #e2e8f0;
         text-align: left;
         margin-top: 30px;
     }

     .empty-state-files .section-title {
         display: flex;
         align-items: center;
         justify-content: space-between;
         margin-bottom: 25px;
         font-size: 20px;
         font-weight: 600;
         color: #2d3748;
         padding-bottom: 15px;
         border-bottom: 2px solid #f7fafc;
     }

     .empty-state-files .section-title::before {
         content: '📁';
         font-size: 24px;
         margin-right: 12px;
     }

     .selected-files-grid {
         display: grid;
         grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
         gap: 20px;
         margin-bottom: 25px;
     }

     /* Horizontal Files Container Styles - Force Override */
     .empty-state-files .files-horizontal-container {
         display: flex !important;
         flex-wrap: wrap !important;
         gap: 12px !important;
         margin-bottom: 20px !important;
         padding: 0 !important;
         align-items: flex-start !important;
         list-style: none !important;
     }

     .empty-state-files .file-card-horizontal {
         background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
         border: 2px solid #e2e8f0 !important;
         border-radius: 12px !important;
         padding: 12px !important;
         min-width: 120px !important;
         max-width: 150px !important;
         text-align: center !important;
         position: relative !important;
         transition: all 0.3s ease !important;
         box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
         flex: 0 0 auto !important;
         display: inline-block !important;
         vertical-align: top !important;
     }

     .empty-state-files .file-card-horizontal:hover {
         transform: translateY(-3px) !important;
         border-color: #6563ff !important;
         background: linear-gradient(135deg, #f0f2ff 0%, #e8ebff 100%) !important;
         box-shadow: 0 8px 20px rgba(101, 99, 255, 0.15) !important;
     }

     .empty-state-files .file-icon-horizontal {
         font-size: 32px !important;
         margin-bottom: 8px !important;
         display: flex !important;
         justify-content: center !important;
         align-items: center !important;
         height: 40px !important;
     }

     .empty-state-files .file-name-horizontal {
         font-size: 12px !important;
         color: #2d3748 !important;
         font-weight: 600 !important;
         line-height: 1.3 !important;
         word-break: break-word !important;
         margin-bottom: 0 !important;
         min-height: 32px !important;
         display: flex !important;
         align-items: center !important;
         justify-content: center !important;
         text-align: center !important;
     }

     .empty-state-files .file-remove-horizontal {
         position: absolute !important;
         top: 6px !important;
         right: 6px !important;
         width: 20px !important;
         height: 20px !important;
         background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%) !important;
         border: none !important;
         color: #dc2626 !important;
         font-size: 10px !important;
         cursor: pointer !important;
         border-radius: 50% !important;
         transition: all 0.3s ease !important;
         opacity: 0 !important;
         display: flex !important;
         align-items: center !important;
         justify-content: center !important;
     }

     .empty-state-files .file-card-horizontal:hover .file-remove-horizontal {
         opacity: 1 !important;
     }

     .empty-state-files .file-remove-horizontal:hover {
         background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;
         color: white !important;
         transform: scale(1.1) !important;
         box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3) !important;
     }

     .empty-state-files .file-card-horizontal.more-files-horizontal {
         background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%) !important;
         border: 2px dashed #cbd5e0 !important;
         display: flex !important;
         align-items: center !important;
         justify-content: center !important;
         color: #718096 !important;
         min-height: 80px !important;
     }

     .empty-state-files .more-files-text {
         display: flex !important;
         flex-direction: column !important;
         align-items: center !important;
         gap: 6px !important;
         font-size: 11px !important;
         font-weight: 500 !important;
     }

     .empty-state-files .more-files-text i {
         font-size: 18px !important;
         color: #a0aec0 !important;
     }

     .file-preview-card {
         background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
         border-radius: 16px;
         padding: 25px;
         text-align: center;
         position: relative;
         transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
         border: 2px solid transparent;
         box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
     }

     .file-preview-card:hover {
         transform: translateY(-5px) scale(1.02);
         border-color: #6563ff;
         background: linear-gradient(135deg, #f0f2ff 0%, #e8ebff 100%);
         box-shadow: 0 12px 32px rgba(101, 99, 255, 0.15);
     }

     .file-preview-card.more-files {
         background: linear-gradient(135deg, #edf2f7 0%, #e2e8f0 100%);
         border: 2px dashed #cbd5e0;
         display: flex;
         align-items: center;
         justify-content: center;
         color: #718096;
     }

     .more-files-content {
         display: flex;
         flex-direction: column;
         align-items: center;
         gap: 10px;
     }

     .more-files-content i {
         font-size: 28px;
         animation: pulse 2s infinite;
     }

     .file-preview-icon {
         font-size: 36px;
         margin-bottom: 15px;
         animation: bounce 2s ease-in-out infinite;
     }

     .file-preview-name {
         font-size: 15px;
         color: #2d3748;
         font-weight: 600;
         word-break: break-word;
         line-height: 1.4;
         max-height: 2.8em;
         overflow: hidden;
         display: -webkit-box;
         -webkit-line-clamp: 2;
         -webkit-box-orient: vertical;
     }

     .file-preview-remove {
         position: absolute;
         top: 10px;
         right: 10px;
         width: 28px;
         height: 28px;
         background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
         border: none;
         color: #dc2626;
         font-size: 14px;
         cursor: pointer;
         border-radius: 50%;
         transition: all 0.3s ease;
         opacity: 0;
         display: flex;
         align-items: center;
         justify-content: center;
     }

     .file-preview-card:hover .file-preview-remove {
         opacity: 1;
     }

     .file-preview-remove:hover {
         background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
         color: white;
         transform: scale(1.1);
         box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
     }

     .empty-state-actions {
         text-align: center;
         padding-top: 20px;
         border-top: 2px solid #f7fafc;
     }

     .empty-state-actions .btn {
         padding: 16px 40px;
         font-size: 16px;
         font-weight: 600;
         border-radius: 12px;
         transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
         background: linear-gradient(135deg, #6563ff 0%, #4834d4 100%);
         border: none;
         color: white;
         box-shadow: 0 4px 16px rgba(101, 99, 255, 0.3);
         position: relative;
         overflow: hidden;
     }

     .empty-state-actions .btn::before {
         content: '';
         position: absolute;
         top: 0;
         left: -100%;
         width: 100%;
         height: 100%;
         background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
         transition: left 0.5s;
     }

     .empty-state-actions .btn:hover::before {
         left: 100%;
     }

     .empty-state-actions .btn:hover:not(:disabled) {
         transform: translateY(-3px);
         box-shadow: 0 8px 24px rgba(101, 99, 255, 0.4);
     }

     .empty-state-actions .btn:disabled {
         opacity: 0.7;
         cursor: not-allowed;
         transform: none;
     }

     /* Responsive Design */
     @media (max-width: 768px) {
         .empty-table-container {
             padding: 40px 20px;
         }

         .table-drop-zone {
             padding: 40px 20px;
             min-height: 300px;
         }

         .empty-state-content h4 {
             font-size: 24px;
         }

         .empty-state-content .text-muted {
             font-size: 16px;
         }

         .drag-drop-area {
             padding: 40px 20px;
         }

         .drag-drop-area h5 {
             font-size: 20px;
         }

         .upload-buttons {
             grid-template-columns: 1fr;
             max-width: 400px;
         }

         .upload-single-btn,
         .upload-bulk-btn {
             width: 100%;
         }

         .selected-files-grid {
             grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
         }

         .files-horizontal-container {
             gap: 8px;
             justify-content: center;
         }

         .file-card-horizontal {
             min-width: 100px;
             max-width: 120px;
             padding: 10px;
         }

         .file-icon-horizontal {
             font-size: 28px;
             height: 35px;
             margin-bottom: 6px;
         }

         .file-name-horizontal {
             font-size: 11px;
             line-height: 1.2;
             min-height: 28px;
         }

         .file-remove-horizontal {
             width: 18px;
             height: 18px;
             font-size: 9px;
             top: 4px;
             right: 4px;
         }

         .more-files-text {
             font-size: 10px;
         }

         .more-files-text i {
             font-size: 16px;
         }

         .empty-state-icon {
             width: 100px;
             height: 100px;
         }

         .empty-state-icon i {
             font-size: 48px;
         }
     }

     /* Bulk Delete Styles */
     .bulk-delete-modal {
         background-color: rgba(0, 0, 0, 0.5);
     }

     .bulk-delete-modal .modal-content {
         border: none;
         border-radius: 8px;
         box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
     }

     .bulk-delete-modal .modal-header {
         border-bottom: 1px solid #e9ecef;
         padding: 1rem 1.5rem;
     }

     .bulk-delete-modal .modal-title {
         display: flex;
         align-items: center;
         color: #2d3748;
         font-size: 1.25rem;
     }

     .bulk-delete-modal .modal-body {
         padding: 1.5rem;
         color: #4a5568;
         font-size: 1rem;
     }

     .bulk-delete-modal .modal-footer {
         border-top: 1px solid #e9ecef;
         padding: 1rem 1.5rem;
     }

     .bulk-delete-modal .alert-warning {
         background-color: #fff3cd;
         border-color: #ffeaa7;
         color: #856404;
     }

     .form-check-input:checked {
         background-color: #6563ff;
         border-color: #6563ff;
     }

     .form-check-input:focus {
         border-color: #6563ff;
         box-shadow: 0 0 0 0.2rem rgba(101, 99, 255, 0.25);
     }

     .table th:first-child,
     .table td:first-child {
         width: 50px;
         text-align: center;
     }

     .btn-danger.smallButtonPrimary {
         background-color: #dc3545;
         border-color: #dc3545;
         color: white;
         transition: all 0.3s ease;
     }

     .btn-danger.smallButtonPrimary:hover {
         background-color: #c82333;
         border-color: #bd2130;
         transform: translateY(-1px);
         box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
     }
    `}
</style>

export default TrustPanel;
